import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

export const FIND_PROMOTION_OVERVIEW_QUERY: GraphQL = {
	name: 'findPromotionOverview',
	gql: gql`
		query findPromotionOverview($companyHotelId: Long!, $filterInput: MarketStateFilterInput!, $includeBookingFunded: Boolean!) {
			findPromotionOverview(companyHotelId: $companyHotelId, filterInput: $filterInput, includeBookingFunded: $includeBookingFunded) {
				meta {
					latestScan baselineScan confirmationScan
					months { year month }
					nightLevelChanges changedHotels startedNights removedNights
					competitorCount competitorsWithDeals90 preferredCompetitorCount
					typicalDepth90 deepestPercentage deepestHotelId deepestDate
				}
				moves {
					hotelId hotelName main action code bookingFunded medianPercentage score fromDate toDate seenInWindow windowScans
					nights { statDate percentageBefore percentageAfter priceBefore priceAfter }
				}
				smallerMoveCount
				rows {
					hotelId hotelName main preferredTier share90 medianDepth90 deepestPercentage deepestDate
					monthly { year month dealNights totalNights tracked }
					nightly { statDate percentage tracked available minimumStay }
					types { code bookingFunded days }
				}
				excludedHotelNames
			}
		}
	`,
};
